import { render, staticRenderFns } from "./storeInfoReviewModal.vue?vue&type=template&id=2d7bf63f&scoped=true"
import script from "./storeInfoReviewModal.vue?vue&type=script&lang=js"
export * from "./storeInfoReviewModal.vue?vue&type=script&lang=js"
import style0 from "./storeInfoReviewModal.vue?vue&type=style&index=0&id=2d7bf63f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7bf63f",
  null
  
)

export default component.exports